import { useSetRecoilState } from 'recoil';
import { CustomerAtom } from '../../atoms/customerAtom';
import { Customer } from '../../providers/customer/types';

export const useUpdateCustomerAccessToken = (): ((accessToken: string) => void) => {
  const setCustomer = useSetRecoilState(CustomerAtom);

  return (accessToken: string) => {
    setCustomer((prevCustomer) => {
      if (!prevCustomer) return prevCustomer;
      return {
        ...prevCustomer,
        access_token: accessToken
      };
    });
  };
}; 